export const getInstallmentCount = (rawAmount: number | string): number => {
  const amount = Number(rawAmount);

  return amount < 500 ? 3 : 5;
};
